import { env } from '@mc/runtime-env'

/**
 * Gets the base path for the application.
 * This value is configured via the EDUCATOR_BASE_PATH environment variable.
 * Defaults to '/executive' if not set.
 */
export const getBasePath = (): string =>
  env('NEXT_PUBLIC_EDUCATOR_BASE_PATH') || '/executive'
